import {Button, Divider, Flex, Typography} from "antd";
import {IUserData} from "../../store/IUserData";

const {Title, Paragraph, Link} = Typography;

const ADMISSION_CONTACT_PHONE_DISPLAY = "+7 (495) 260-23-32";
const ADMISSION_CONTACT_PHONE_TEL = "+74952602332";
const ADMISSION_CONTACT_EMAIL_ADDRESS = "pk@rut-miit.ru";

export interface AdmissionListContactsBodyProps {
    user: IUserData;
    admissionMailtoHref: string;
    idSs: string | null;
}

export default function AdmissionListContactsBody({user, admissionMailtoHref, idSs}: AdmissionListContactsBodyProps) {
    return (
        <>
            <section className={"admission-list-contacts-section"}>
                <Title level={5} className={"admission-list-contacts-section-title"}>
                    Идентификатор
                </Title>
                <Paragraph className={"admission-list-contacts-competition-id"}>
                    Ваш идентификатор в конкурсных списках высшего образования:{" "}
                    <strong>{String(idSs ?? "").trim() ? idSs : "—"}</strong>
                </Paragraph>
            </section>
            <Divider className={"admission-list-contacts-divider"}/>
            <section className={"admission-list-contacts-section"}>
                <Title level={5} className={"admission-list-contacts-section-title"}>
                    Контакты
                </Title>
                <Paragraph className={"admission-list-contacts-intro"}>
                    По вопросам приёмной кампании вы можете обратиться по указанным телефону или адресу электронной почты.
                </Paragraph>
                <Flex vertical gap={12} className={"admission-list-contacts-list"}>
                    <div>
                        <div className={"admission-list-contacts-label"}>Телефон</div>
                        <Link href={`tel:${ADMISSION_CONTACT_PHONE_TEL}`} className={"admission-list-contacts-value"}>
                            {ADMISSION_CONTACT_PHONE_DISPLAY}
                        </Link>
                    </div>
                    <div>
                        <div className={"admission-list-contacts-label"}>Электронная почта</div>
                        <Button
                            type={"link"}
                            href={admissionMailtoHref}
                            className={"admission-list-contacts-mail-btn"}
                        >
                            {ADMISSION_CONTACT_EMAIL_ADDRESS}
                        </Button>
                    </div>
                </Flex>
            </section>
        </>
    );
}

export {
    ADMISSION_CONTACT_PHONE_DISPLAY,
    ADMISSION_CONTACT_PHONE_TEL,
    ADMISSION_CONTACT_EMAIL_ADDRESS,
};
